import {
    state as baseState,
    getters as baseGetters,
    actions as baseActions,
    mutations as baseMutations,
} from '@puzzleapps/shared/src/store/modules/game'

const state = {
    ...baseState,

    correctOnFirst: 0,

    categories: [
        {id: 1, title: 'General Knowledge', urlParam: 'general-knowledge'},
        {id: 2, title: 'Dictionary', urlParam: 'dictionary'},
        {id: 3, title: 'Entertainment', urlParam: 'entertainment'},
        {id: 4, title: 'History', urlParam: 'history'},
        {id: 5, title: 'Food & Drink', urlParam: 'food'},
        {id: 6, title: 'Geography', urlParam: 'geography'},
        {id: 7, title: 'Science & Nature', urlParam: 'science'},
        {id: 8, title: 'Everything', urlParam: 'all'},
    ],

}

const getters = {
    ...baseGetters,
    getCategoryById: state => id => state.categories.find(c => c.id === id)
}

const actions = {
    ...baseActions,

    init({ commit, state, dispatch, rootState }) {
        dispatch('setCompleted', false)
        dispatch('userSettings/setAllowHints', false, {root:true})

        dispatch('grid/fetchPuzzle', this.type, {root: true})
        .then(res => {
            dispatch('setPlayId')
            dispatch('setIsPlaying', true)
        })
    },

    goToPuzzleRoute({ dispatch }, {router, id}) {
        dispatch('setPuzzleId', id)

        router.push({
            name: 'Game',
            params: {
                clientAppId: window.PE_CLIENTAPP_ID,
            },
            path: '/game'
        })
    },

    incrementCorrectOnFirst({ commit }) {
        commit('INCREMENT_CORRECT_ON_FIRST')
    }

}

const mutations = {
    ...baseMutations,

    INCREMENT_CORRECT_ON_FIRST(state) {
        state.correctOnFirst++
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}